// import React, { useState } from "react";
// import Highcharts, { Legend } from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import "./DrillDownComponent.css";

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const DrillDownComponent = () => {
//   const [level, setLevel] = useState(0);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedSubcategory, setSelectedSubcategory] = useState(null);

//   const breadcrumbs = [
//     { label: "Category", level: 0, action: () => resetNavigation() },
//     ...(selectedCategory
//       ? [
//           {
//             label: ` ${selectedCategory}`,
//             level: 1,
//             action: () => goToCategory(selectedCategory),
//           },
//         ]
//       : []),
//     ...(selectedSubcategory
//       ? [
//           {
//             label: ` ${selectedSubcategory}`,
//             level: 2,
//             action: () => goToSubcategory(selectedSubcategory),
//           },
//         ]
//       : []),
//   ];

//   const resetNavigation = () => {
//     setLevel(0);
//     setSelectedCategory(null);
//     setSelectedSubcategory(null);
//   };

//   const goToCategory = (category) => {
//     setLevel(1);
//     setSelectedCategory(category);
//     setSelectedSubcategory(null);
//   };

//   const goToSubcategory = (subcategory) => {
//     setLevel(2);
//     setSelectedSubcategory(subcategory);
//   };

//   const getChartOptions = () => {
//     const data = Object.entries(
//       manualData[selectedCategory][selectedSubcategory] || {}
//     ).map(([network, price]) => ({
//       name: network,
//       y: typeof price === "number" ? price : null,
//     }));

//     return {
//       chart: { type: "column" },
//       title: null,
//       // xAxis: {
//       //   categories: data.map((d) => d.name),
//       //   title: { text: "Networks" },
//       // },

//       yAxis: { title: { text: "% of Medicare " } },
//       title: {
//         text: "Categories Comparison: % of Medicare",
//         align: "center",
//         style: {
//           color: "#333333",
//           fontFamily: "'Montserrat', serif",
//           fontSize: "20px",
//           fontWeight: "bold",
//         },
//       },
//       xAxis: {
//         categories: data.map((d) => d.name),
//         title: { text: "Networks" },
//         title: {
//           text: null,
//         },
//         labels: {
//           style: {
//             fontSize: "12px",
//             width: "100px",
//           },
//         },
//       },
//       yAxis: {
//         title: {
//           text: "% of Medicare",
//           style: {
//             fontSize: "14px",
//             fontWeight: "light",
//             fontFamily: "'Roboto Flex', serif",
//           },
//         },
//         // plotLines: [
//         //   {
//         //     value: 70,
//         //     dashStyle: "dash",
//         //     width: 1,
//         //     color: "#B4B4B4",
//         //     zIndex: 5,
//         //     label: {
//         //       text: "threshold",
//         //       align: "right",
//         //       verticalAlign: "top",
//         //       rotation: 0,
//         //       x: 10,
//         //       y: -5,
//         //       style: {
//         //         color: "#666",
//         //         fontSize: "10px",
//         //         fontWeight: "light",
//         //       },
//         //     },
//         //   },
//         // ],
//       },
//       legend: {
//         enabled: false, // Disables the legend
//       },

//       credits: {
//         enabled: false,
//       },
//       plotOptions: {
//         series: {
//           borderRadius: 3,
//           pointPadding: 0.2,
//           groupPadding: 0.1,
//           dataLabels: {
//             enabled: true,
//             // format: "{y}%",
//             style: {
//               fontSize: "12px",
//               fontWeight: "bold",
//               color: "black",
//             },
//             inside: false,
//           },
//           cursor: "pointer",
//           states: {
//             hover: {
//               enabled: false,
//             },
//           },
//         },
//       },
//       tooltip: {
//         headerFormat:
//           '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
//           '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
//         pointFormat:
//           "<span style='margin-right:100px; width:45px'> {series.name}</span> <span style='display: inline-block;position:absolute;padding-left:-2px;width: 50px; text-align:right;right:0'><b>{point.y}%</span></b><br/>",

//         shared: true,
//         backgroundColor: "rgba(255, 255, 255, 1)",
//         borderColor: "#A9A9A9",
//         borderRadius: 7,
//         animation: false,
//         hideDelay: 0,
//         style: {
//           color: "#333",
//           fontFamily: "'Roboto Flex', serif",
//           transition: "none",
//           fontSize: "12px",
//           padding: "8px",
//           shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
//           zIndex: 99999,
//         },
//         shadow: true,
//         useHTML: true,
//         outside: true,
//       },
//       series: [{ name: "% of Medicare", data, colorByPoint: true }], // This mak],
//       colors: ["#C1E7E7", "#4F7A8A", "#D1E8FF", "#FFD2A0"],
//     };
//   };

//   return (
//     <div className="container1">
//       {/* Breadcrumbs */}
//       <nav className="breadcrumbs">
//         <ul className="breadcrumbs-list">
//           {breadcrumbs.map((crumb, index) => (
//             <li key={index} className="breadcrumb-item">
//               <button
//                 className={`breadcrumb-button ${
//                   level === crumb.level ? "active" : "hover"
//                 }`}
//                 onClick={crumb.action}
//               >
//                 {crumb.label}
//               </button>
//               {index < breadcrumbs.length - 1 && (
//                 <span className="breadcrumb-separator">/</span>
//               )}
//             </li>
//           ))}
//         </ul>
//       </nav>

//       {/* Content Card */}
//       <div className="content-card">
//         {level === 0 && (
//           <div>
//             <h2 className="title">Select a Category</h2>
//             <ul className="category-list">
//               {Object.keys(manualData).map((category, index) => (
//                 <li key={index}>
//                   <button
//                     className="category-button"
//                     onClick={() => goToCategory(category)}
//                   >
//                     {category}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         )}

//         {level === 1 && selectedCategory && (
//           <div>
//             <h2 className="title">{selectedCategory}</h2>
//             <ul className="subcategory-list">
//               {Object.keys(manualData[selectedCategory]).map(
//                 (subcategory, index) => (
//                   <li key={index}>
//                     <button
//                       className="subcategory-button"
//                       onClick={() => goToSubcategory(subcategory)}
//                     >
//                       {subcategory}
//                     </button>
//                   </li>
//                 )
//               )}
//             </ul>
//           </div>
//         )}

//         {level === 2 && selectedSubcategory && selectedCategory && (
//           <div>
//             {/* <h2 className="title">{selectedSubcategory}</h2> */}
//             <div className="chart-container">
//               <HighchartsReact
//                 highcharts={Highcharts}
//                 options={getChartOptions()}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DrillDownComponent;

import React, { useState, useRef, useEffect } from "react";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "bootstrap/dist/css/bootstrap.min.css";

import { FaBars } from "react-icons/fa";
import html2canvas from "html2canvas";

import "../App.css";

const manualData = {
  "Category III Codes": {
    "Prostate Ablation Procedure": {
      "Anthem Participating Network": 272.95,
      "BC ID Blue Value POS Network": 333.09,
      "BC ID Preferred Blue Network": 333.09,
      "BC ID Preferred Blue PPO Network": 294.65,
    },
    "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
      "Anthem Participating Network": 147.22,
      "BC ID Blue Value POS Network": 147.22,
      "BC ID Preferred Blue Network": 147.22,
      "BC ID Preferred Blue PPO Network": 147.22,
    },
    "Laser Ablation Procedures": {
      "Anthem Participating Network": 605.01,
      "BC ID Blue Value POS Network": 605.01,
      "BC ID Preferred Blue Network": 605.01,
      "BC ID Preferred Blue PPO Network": 605.01,
    },
    "Stereotactic Intracranial Lesion Ablation Procedure": {
      "Anthem Participating Network": 338.44,
      "BC ID Blue Value POS Network": 298.36,
      "BC ID Preferred Blue Network": 298.36,
      "BC ID Preferred Blue PPO Network": 338.44,
    },
    "Transnasal EGD and Capsule Endoscopy Procedures": {
      "Anthem Participating Network": 584.68,
      "BC ID Blue Value POS Network": 584.68,
      "BC ID Preferred Blue Network": 584.68,
      "BC ID Preferred Blue PPO Network": 584.68,
    },
    "Carotid Sinus Baroreflex Activation Device Procedures": {
      "Anthem Participating Network": 278.66,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 278.66,
    },
    "Imaging, Testing, Implantation and Other Services": {
      "Anthem Participating Network": 619.55,
      "BC ID Blue Value POS Network": 619.55,
      "BC ID Preferred Blue Network": 619.55,
      "BC ID Preferred Blue PPO Network": 619.55,
    },
    "Insertion of Aqueous Drainage Device": {
      "Anthem Participating Network": 207.97,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 207.97,
    },
    "Intracardiac Ischemia Monitoring Procedures": {
      "Anthem Participating Network": 153.86,
      "BC ID Blue Value POS Network": 153.86,
      "BC ID Preferred Blue Network": 153.86,
      "BC ID Preferred Blue PPO Network": 153.86,
    },
    "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
      "Anthem Participating Network": 178.15,
      "BC ID Blue Value POS Network": 178.15,
      "BC ID Preferred Blue Network": 178.15,
      "BC ID Preferred Blue PPO Network": 178.15,
    },
  },
  "Chemotherapy Drugs": {
    "Chemotherapy Drugs": {
      "Anthem Participating Network": 250.98,
      "BC ID Blue Value POS Network": 243.03,
      "BC ID Preferred Blue Network": 243.03,
      "BC ID Preferred Blue PPO Network": 242.29,
    },
  },
  "Drugs Administered Other than Oral Method": {
    "Drugs, Administered by Injection": {
      "Anthem Participating Network": 260.7,
      "BC ID Blue Value POS Network": 247.36,
      "BC ID Preferred Blue Network": 247.36,
      "BC ID Preferred Blue PPO Network": 252.38,
    },
    "Miscellaneous Drugs": {
      "Anthem Participating Network": 234.78,
      "BC ID Blue Value POS Network": 239.27,
      "BC ID Preferred Blue Network": 239.27,
      "BC ID Preferred Blue PPO Network": 235.47,
    },
    "Clotting Factors": {
      "Anthem Participating Network": 227.49,
      "BC ID Blue Value POS Network": 215.47,
      "BC ID Preferred Blue Network": 215.47,
      "BC ID Preferred Blue PPO Network": 214.66,
    },
    "Chemotherapy Drugs, Oral Administration": {
      "Anthem Participating Network": 241.13,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 241.13,
    },
    "Immunosuppressive Drugs": {
      "Anthem Participating Network": 188.53,
      "BC ID Blue Value POS Network": 188.53,
      "BC ID Preferred Blue Network": 188.53,
      "BC ID Preferred Blue PPO Network": 188.53,
    },
  },
  "Evaluation and Management": {
    "Preventive Medicine Services": {
      "Anthem Participating Network": 298.53,
      "BC ID Blue Value POS Network": 288.5,
      "BC ID Preferred Blue Network": 288.5,
      "BC ID Preferred Blue PPO Network": 312.29,
    },
    "Transitional Care Management Services": {
      "Anthem Participating Network": 309.17,
      "BC ID Blue Value POS Network": 314.26,
      "BC ID Preferred Blue Network": 314.26,
      "BC ID Preferred Blue PPO Network": 322.86,
    },
    "Psychiatric Collaborative Care Management Services": {
      "Anthem Participating Network": 293.26,
      "BC ID Blue Value POS Network": 213.38,
      "BC ID Preferred Blue Network": 213.38,
      "BC ID Preferred Blue PPO Network": 293.26,
    },
    "Care Management Services": {
      "Anthem Participating Network": 204.65,
      "BC ID Blue Value POS Network": 204.65,
      "BC ID Preferred Blue Network": 204.65,
      "BC ID Preferred Blue PPO Network": 204.65,
    },
    "Newborn Care Services": {
      "Anthem Participating Network": 389.88,
      "BC ID Blue Value POS Network": 389.88,
      "BC ID Preferred Blue Network": 389.88,
      "BC ID Preferred Blue PPO Network": 389.88,
    },
    "Delivery/Birthing Room Attendance and Resuscitation Services": {
      "Anthem Participating Network": 209.07,
      "BC ID Blue Value POS Network": 209.07,
      "BC ID Preferred Blue Network": 209.07,
      "BC ID Preferred Blue PPO Network": 209.07,
    },
  },
  "Medicine Services and Procedures": {
    "Cardiovascular Procedures": {
      "Anthem Participating Network": 360.68,
      "BC ID Blue Value POS Network": 339.42,
      "BC ID Preferred Blue Network": 339.42,
      "BC ID Preferred Blue PPO Network": 359.71,
    },
  },
};

const colorPalette = ["#c0e7e7", "#507a8a", "#d1e8ff", "#ffd29f"];

const BasicColumnChart = () => {
  const [selectedCategory, setSelectedCategory] =
    useState("Category III Codes");
  const chartData = manualData[selectedCategory] || {};

  const subcategories = Object.keys(chartData).sort();

  const networkTypes = subcategories.length
    ? Object.keys(chartData[subcategories[0]])
    : [];

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [isFullScreen, setIsFullScreen] = useState(false);

  const chartContainerRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => {
      return !prev;
    });
  };
  // const handleSelect = (eventKey) => {
  //   setSelectedOption(eventKey);
  // };

  const handleFullScreen = () => {
    if (chartContainerRef.current) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        chartContainerRef.current.requestFullscreen().catch((err) => {
          console.error("Error attempting fullscreen:", err);
        });
      }
    }
  };
  // const captureScreenshot = async () => {
  //   if (chartContainerRef.current) {
  //     const canvas = await html2canvas(chartContainerRef.current, {
  //       useCORS: true,
  //       scale: 2,
  //       fontFamily: "'Roboto Flex', serif !important", // Make sure the font is applied here
  //     });
  //     const image = canvas.toDataURL("image/png");
  //     const link = document.createElement("a");
  //     link.href = image;
  //     link.download = "graph.png";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     toggleDropdown(false);
  //   }
  // };

  const captureScreenshot = async () => {
    setDropdownOpen(false);

    const buttonElement = document.getElementById("capture-hide");
    if (buttonElement) {
      buttonElement.style.visibility = "hidden";
    }

    await new Promise((resolve) => setTimeout(resolve, 50));

    if (chartContainerRef.current) {
      await document.fonts.load('1em "Roboto Flex, serif !important"');
      const canvas = await html2canvas(chartContainerRef.current, {
        useCORS: true,
        scale: 2,
        backgroundColor: "#FFFFFF",

        onclone: (clonedDoc) => {
          clonedDoc.body.style.fontFamily = "'Roboto Flex', serif !important";
        },
      });

      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = "graph.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    if (buttonElement) {
      buttonElement.style.visibility = "visible";
    }
  };
  useEffect(() => {
    const checkFontLoaded = () => {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          // You can now safely capture the screenshot
        });
      }
    };

    window.onload = checkFontLoaded;

    return () => {
      window.onload = null;
    };
  }, []);

  useEffect(() => {
    const onFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", onFullScreenChange);
  }, []);

  const series = networkTypes.map((network, index) => ({
    name: network,
    data: subcategories.map((subcategory) =>
      chartData[subcategory][network] === "Unavailable"
        ? null
        : chartData[subcategory][network]
    ),
    color: colorPalette[index % colorPalette.length], // Assign colors dynamically
  }));

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: `Category: ${selectedCategory} `,
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif !important",
        fontSize: "20px",
        fontWeight: "bold",
      },
    },
    xAxis: {
      categories: subcategories,
      labels: {
        rotation: 0,
        style: {
          fontFamily: "'Roboto Flex', serif !important",
          fontSize: "12px",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          fontSize: "12px",
          width: "100px",
        },
      },
    },

    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;  max-width: 220px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      pointFormat:
        "<div style='display:flex; flex-direction:row, align-items: center', justify-content: 'space-between'><div style='margin-right: 0px; width:200px'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false,
      hideDelay: 0,
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        transition: "none",
        fontSize: "12px",
        padding: "8px",
        shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
        zIndex: 99999,
      },
      shadow: true,
      useHTML: true,
      outside: true,
    },

    exporting: { enabled: false },
    plotOptions: {
      series: {
        borderRadius: 3,
        pointPadding: 0.2,
        groupPadding: 0.1,
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            opacity: 1,
          },
          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
        dataLabels: {
          enabled: true,
          format: "{y:.0f}", // shows whole numbers only
          style: {
            fontFamily: "'Roboto Flex', serif !important",
            fontSize: "9px",
            fontWeight: 500,
            color: "black",
          },
          inside: false,
        },
        cursor: "pointer",
      },
    },
    yAxis: {
      title: {
        text: "% of Medicare",
        style: {
          // color: "#555555",
          fontSize: "12px",
          fontFamily: "'Roboto Flex', serif !important",
          letterSpacing: "-0.75px",
        },
      },
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif !important",
      },
    },
    credits: {
      enabled: false,
    },
    series: series,
  };

  const options1 = {
    chart: {
      type: "column",
    },
    title: {
      text: `Category: ${selectedCategory} `,
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif !important",
        fontSize: "20px",
        fontWeight: "bold",
      },
    },
    subtitle: {
      text: "(Without Data labels)", // Add subtitle here
      style: {
        color: "grey",
        fontFamily: "'Montserrat', serif !important",
        fontSize: "14px",
        fontWeight: "light",
      },
    },
    xAxis: {
      categories: subcategories,
      labels: {
        rotation: 0,
        style: {
          fontFamily: "'Roboto Flex', serif !important",
          fontSize: "12px",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          fontSize: "12px",
          width: "100px",
        },
      },
    },

    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;  max-width: 220px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      pointFormat:
        "<div style='display:flex; flex-direction:row, align-items: center', justify-content: 'space-between'><div style='margin-right: 0px; width:200px'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false,
      hideDelay: 0,
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        transition: "none",
        fontSize: "12px",
        padding: "8px",
        shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
        zIndex: 99999,
      },
      shadow: true,
      useHTML: true,
      outside: true,
    },

    exporting: { enabled: false },
    plotOptions: {
      series: {
        borderRadius: 3,
        pointPadding: 0.2,
        groupPadding: 0.1,
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            opacity: 1,
          },
          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
        dataLabels: {
          enabled: false,
          style: {
            fontFamily: "'Roboto Flex', serif !important",
            fontSize: "9px",
            fontWeight: 500,
            color: "black",
          },
          inside: false,
        },
        cursor: "pointer",
      },
    },
    yAxis: {
      title: {
        text: "% of Medicare",
        style: {
          // color: "#555555",
          fontSize: "12px",
          fontFamily: "'Roboto Flex', serif !important",
          letterSpacing: "-0.75px",
        },
      },
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif !important",
      },
    },
    credits: {
      enabled: false,
    },
    series: series,
  };
  return (
    <div
      className="bg-white p-4 "
      style={{ border: "none", borderRadius: "8px", margin: "0px 20px" }}
    >
      <label className="form-label">Select Category:</label>
      <div className="dropdown">
        <a
          className="btn  dropdown-toggle text-align-left"
          variant="primary"
          id="dropdown-basic"
          href="#"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {selectedCategory || "Select Category"}
        </a>

        <ul className="dropdown-menu">
          {Object.keys(manualData).map((category) => (
            <li key={category}>
              <a
                className="dropdown-item"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedCategory(category);
                }}
              >
                {category}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div
        className="position-relative d-flex justify-content-end "
        style={{ marginBottom: "-40px", zIndex: "999999" }}
      >
        {/* Menu button */}

        <button className="btn border p-2 " onClick={toggleDropdown}>
          <FaBars size={20} />
        </button>

        {/* Dropdown Menu */}
        {dropdownOpen && (
          <div
            className="position-absolute bg-white border rounded shadow p-2"
            style={{
              right: 0,
              top: "110%",
              minWidth: "180px",
              zIndex: 10,
            }}
          >
            <button className="dropdown-item p-2" onClick={captureScreenshot}>
              Download
            </button>
            <button className="dropdown-item p-2" onClick={handleFullScreen}>
              {isFullScreen ? "Exit Full Screen" : "View Full Screen"}
            </button>
          </div>
        )}
      </div>

      <div
        ref={chartContainerRef}
        className={`chart-container p-1 ${isFullScreen ? "fullscreen" : ""}`}
      >
        <HighchartsReact highcharts={Highcharts} options={options} />
        <HighchartsReact highcharts={Highcharts} options={options1} />
      </div>
    </div>
  );
};

export default BasicColumnChart;
